// @ts-ignore
import Config from 'Config';

const AB_TASTY_EVENT_WAIT_TIMEOUT = 10_000; // 10 seconds

// Although this function returns a promise, you probably don't want/need to
// await the result. You can safely fire and forget this wherever you need to
// send an AB Tasty custom event.
// https://developers.abtasty.com/docs/data/uc-hits#event
export async function sendABTastyCustomEvent(eventName: string): Promise<void> {
  if (!window || Config.Environment.ENVIRONMENT_TYPE !== 'production') {
    console.log(`%c⚡️ ABTASTY - ${eventName}`, 'color: #962857;font-weight:bold;');
    return;
  }

  const startTime = Date.now();
  try {
    // Retry in a loop in case AB tasty hasn't loaded
    while (Date.now() - startTime < AB_TASTY_EVENT_WAIT_TIMEOUT) {
      if (typeof (window as any)?.abtasty?.send === 'function') {
        (window as any)?.abtasty?.send('event', {
          ec: 'Action Tracking', // Required to be 'Action Tracking'
          ea: eventName,
        });

        return;
      }

      await new Promise<void>(resolve => {
        setTimeout(() => resolve(), 10);
      });
    }

    console.warn('Timed out waiting for abtasty.send to load');
  } catch (e) {
    console.error(`Error loading abtasty.send ${e}`);
  }
}
